import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import store from '../../store';
import { Button, Popup } from '@smartplatform/ui';
import { Formik, Field, Form } from 'formik';

@observer
export default class PollFieldList extends React.Component {
	@observable pollField;

	componentDidMount() {
		this.init();
	}

	init = async () => {
		const { id, pollId } = this.props;
		if (id) {
			this.pollField = await store.model.PollField.findById(id);
		} else {
			this.pollField = await new store.model.PollField({ pollId });
		}
	};

	delete = async () => {
		await this.pollField.delete();
		this.props.onClose();
	};

	render() {
		if (!this.pollField) {
			return <div>...</div>;
		}
		const { name = '', user = false } = this.pollField;
		return (
			<Popup width={500} height={300} onClose={() => this.props.onClose()} scrollable={false}>
				<div className="poll-field-form">
					<Formik
						initialValues={{ name, user }}
						onSubmit={async (values, actions) => {
							Object.assign(this.pollField, values);
							await this.pollField.save();
							this.props.onClose();
						}}
					>
						{props => (
							<Form>
								{!props.values.user && (
									<div className="form-field">
										<label>Название поля</label>
										<Field name="name" />
									</div>
								)}
								<div className="form-field">
									<label>Пользовательский вариант</label>
									<Field type="checkbox" name="user" />
								</div>
								{(props.values.name !== '' || props.values.user) && (
									<div className="poll-field-buttons">
										<Button className="btn-primary" label="Сохранить" type="submit" />
										<Button className="btn-warning" label="Удалить" onClick={this.delete} />
									</div>
								)}
							</Form>
						)}
					</Formik>
				</div>
			</Popup>
		);
	}
}
